import { render, staticRenderFns } from "./GroupTransfer.vue?vue&type=template&id=51c92e13&scoped=true&"
import script from "./GroupTransfer.vue?vue&type=script&lang=js&"
export * from "./GroupTransfer.vue?vue&type=script&lang=js&"
import style0 from "./GroupTransfer.vue?vue&type=style&index=0&id=51c92e13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c92e13",
  null
  
)

export default component.exports